import { render } from "./CreateProduct.vue?vue&type=template&id=210d4da4"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=210d4da4&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__